var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"active":"admin_users"}}),_c('CrudList',{attrs:{"tableName":"admin_user","tableNamePlural":"admin_users","defaultSort":"id","columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }